export const initialFilters = {
    status: {
      cancelled: false,
    },
    type: {
      purchaseTag: false,
      paidCoupon: false,
    },
    archive: {
      showInArchive: false,
      showAll: false,
    },
  };

export const BENEFIT_DEEP_LINK_BASE_URL = 'https://dl.hot.co.il/b';

export const BALANCE_INQUIRY_TEXT_KEY = 'personal_zone_balance_inquiry_text';

export const getBalanceInquiryText = (translate) => {
  const text = translate(BALANCE_INQUIRY_TEXT_KEY);
  if (!text || text === BALANCE_INQUIRY_TEXT_KEY) {
    return null;
  }
  return text;
};